import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

import UserInterface from './components/UserInterface';
import { UserContextProvider } from "./context/user-context";
import { MessageContextProvider } from "./context/message-context";
import { SessionContextProvider } from "./context/session-context";
import { BalanceContextProvider } from "./context/balance-context";

import './App.css';

class App extends Component {

  constructor(props) {
    super(props);
  }
    render() {
      return (       
        <MessageContextProvider>
          <SessionContextProvider>
            <UserContextProvider>
              <BalanceContextProvider>
                <Router>
                  <Switch>
                    <Route path="/login">
                      <UserInterface isLogin={true} />
                    </Route>
                    <Route path="/forgotten-password">
                      <UserInterface isForgotten={true} />
                    </Route>
                    <Route path="/register">
                      <UserInterface isRegister={true} />
                    </Route>
                    <Route path="/demo">
                      <UserInterface isDemo={true} />
                    </Route>
                    <Route path="/">
                      <UserInterface />
                    </Route>
                  </Switch>
                </Router>
              </BalanceContextProvider>
            </UserContextProvider>
          </SessionContextProvider>
        </MessageContextProvider>
        );
    }
}

export default App;